import { companyInfo, heroImages } from "@/mocks/home";
import hero from "@/assets/hero.png";
import heromb from "@/assets/heromb.png";
import plus from "@/assets/plus.png";

export default function Hero() {
  return (
    // モバイル時は items-start と pt-28 で上部に配置され、テキストは左寄せ（text-left）になっています
    <section id="hero" className="relative min-h-[100dvh] flex items-start md:items-center overflow-hidden pt-10 md:pt-0">
      <div className="absolute inset-0">
        <img
          src={hero}
          alt="車両輸送トラック"
          className="hidden md:block w-full h-full object-cover object-center"
        />
        <img
          src={heromb}
          alt="車両輸送トラック"
          className="block md:hidden w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-100/95 via-background-100/20 to-background-100/0"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-background-100 via-background-100/0 to-background-100/0"></div>
      </div>

      <div className="relative z-10 w-full pl-5 pr-5 md:pr-0">
        <div className="site-container relative">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start md:items-center pt-8">
            <div className="space-y-4 md:space-y-5 text-left">
              <p className="text-primary-400 text-sm md:text-base lg:text-xl">全国対応・車両買取・輸出・業販</p>

              <h1 className="text-3xl md:text-5xl lg:text-6xl font-black font-heading text-foreground-50 leading-tight">
                信頼でつなぐ、
                <br />
                価値ある一台。
              </h1>

              <p className="text-foreground-400 text-xs md:text-base leading-relaxed max-w-xl">
                日本全国どこでも対応。
                <br />
                車両・重機・機械類の買取・輸出・業販は
                <br />
                お任せください。
              </p>

              <div className="flex flex-col items-start sm:flex-row gap-4 mt-4">
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="inline-flex items-center justify-center font-heading gap-2 bg-primary-600 hover:bg-primary-600 text-foreground-50 px-6 py-3 rounded-md font-bold text-base transition-all duration-200 whitespace-nowrap"
                >
                  <i className="ri-phone-line"></i>
                  090-5615-5500
                </a>
              </div>
            </div>
            <img src={plus} alt="" className="absolute -bottom-24 right-0 hidden md:block z-10 w-40 md:w-40 lg:w-52" />
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 inset-x-0 flex justify-center z-10 animate-bounce">
        <a href="#services" className="text-foreground-500 hover:text-primary-400 transition-colors">
          <i className="ri-arrow-down-double-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}